import React from "react";
import { Typography } from "@material-ui/core";

const AgeRes = ({ AgeError }) => {
  return (
    <>
      <Typography style={{ fontSize: "12px", marginTop: 5, paddingTop: 3 }}>
        I confirm that I am above 16 years age
      </Typography>
    </>
  );
};

export default AgeRes;
